import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppLayout from '../AppLayout/AppLayout';
import DashboardLayout from '../DashboardLayout/DashboardLayout';
import { useGoogleOneTap } from '@/hooks/auth/useGoogleOneTap.hook';
import { AppGuard, EGuardType } from '../AppGuard/AppGuard';
import FullPageLoader from '@/components/layout/FullPageLoader/FullPageLoader';
import { LEGACY_ROUTES, ROUTES } from '@/constants/app/routes';
import { ANALYTICS } from '@/constants/analytics/analytics';

const CustomizeBlockPage = lazy(
  () => import('../../pages/CustomizeBlockPage/CustomizeBlockPage')
);
const HomePage = lazy(() => import('../../pages/Home/Home.page'));
const AboutPage = lazy(() => import('../../pages/About/About.page'));
const PurchaseFlow = lazy(() => import('@/pages/PurchasePage/PurchaseFlow'));
// const InsightsPage = lazy(() => import('../../pages/Insights/Insights.page'));
const InsightsPage = lazy(() => import('../../pages/Insights/Insights.page'));
const SettingsPage = lazy(() => import('../../pages/Settings/Settings.page'));
const WebHistoryCallbackPage = lazy(
  () => import('../../pages/WebHistoryCallback/WebHistoryCallback')
);
const Uninstall = lazy(() => import('../../pages/Uninstall/Uninstall'));
const BlockedPage = lazy(() => import('../../pages/Blocked/Blocked.page'));

const AppRoutes: React.FC = () => {
  useGoogleOneTap();
  return (
    <AppLayout>
      <Routes>
        <Route
          path={ROUTES.WEB_HISTORY_CALLBACK}
          element={
            <Suspense fallback={<FullPageLoader />}>
              <WebHistoryCallbackPage />
            </Suspense>
          }
        />
        <Route
          path={ROUTES.PURCHASE}
          element={
            <Suspense fallback={<FullPageLoader />}>
              <PurchaseFlow source={ANALYTICS.VALUES.PURCHASE_PAGE} />
            </Suspense>
          }
        />
        <Route
          path={ROUTES.UNINSTALL}
          element={
            <Suspense fallback={<FullPageLoader />}>
              <Uninstall />
            </Suspense>
          }
        />
        <Route
          path={ROUTES.BLOCKED}
          element={
            <Suspense fallback={<FullPageLoader />}>
              <BlockedPage />
            </Suspense>
          }
        />
        {/*place here routes outside the default template*/}
        <Route
          path={'*'}
          element={
            <DashboardLayout>
              <Routes>
                <Route
                  path={ROUTES.HOME}
                  element={
                    <AppGuard
                      guardTypes={[EGuardType.extensionMinVersion]}
                      legacyRoute={LEGACY_ROUTES.BLOCK_SITES}
                    >
                      <HomePage />
                    </AppGuard>
                  }
                />
                {/*<Route path={ROUTES.INSIGHTS} element={<InsightsPage />} />*/}
                <Route
                  path={ROUTES.CUSTOMIZE_BLOCK_PAGE}
                  element={<CustomizeBlockPage />}
                />
                <Route path={ROUTES.ABOUT} element={<AboutPage />} />
                <Route
                  path={ROUTES.SETTINGS}
                  element={
                    <AppGuard
                      guardTypes={[EGuardType.extensionMinVersion]}
                      legacyRoute={LEGACY_ROUTES.SETTINGS}
                    >
                      <SettingsPage />
                    </AppGuard>
                  }
                />
              </Routes>
            </DashboardLayout>
          }
        />
      </Routes>
    </AppLayout>
  );
};

export default AppRoutes;
